module.exports = flarum.core.compat['common/Fragment'];